import { addFavoriteLabel, newFavoritePickedText } from './FavoritesList.locstring.json';
import loc, { format } from 'owa-localize';
import FavoriteNode from './FavoriteNode';
import { observer } from 'mobx-react';
import { logMountingPerformance } from 'owa-analytics';
import { logUsage } from 'owa-analytics';
import { getStore as getSharedFavoritesStore } from 'owa-favorites';
import { getStore as getMailFavoritesStore } from 'owa-mail-favorites-store';
import { FavoritesPicker } from 'owa-mail-favorites-picker';
import { showFindFavoritesPicker } from 'owa-mail-favorites-store';
import { FavoriteNodeContextMenu } from 'owa-mail-favorites-view';
import { hideFavoritesContextMenu } from 'owa-mail-favorites-store/lib/actions/favoritesContextMenu';

import TreeNode from 'owa-tree-node/lib/components/TreeNode';
import * as React from 'react';
import { isFeatureEnabled } from 'owa-feature-flags';
import FavoriteNodeV2 from './roaming/FavoriteNodeV2';
import { computed } from 'mobx';

const styles = require('./FavoritesList.scss');

@observer
@logMountingPerformance('FavoriteFolderList')
export default class FavoritesList extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            favoriteAddedText: '',
        };
    }

    @computed
    get favoritesStore() {
        return getSharedFavoritesStore();
    }

    render() {
        return (
            <div>
                {isFeatureEnabled('tri-favorites-roaming')
                    ? this.renderOutlookFavorites()
                    : this.renderFavoriteNodes()}
                {this.renderContextMenuIfOpen()}
                {this.renderFindFavoritesComponents()}
                <span className="screenReaderOnly" aria-live="assertive" aria-atomic="true">
                    {this.state.favoriteAddedText}
                </span>
            </div>
        );
    }

    private renderOutlookFavorites(): JSX.Element[] {
        return this.favoritesStore.orderedOutlookFavoritesIds.map(favoriteId => {
            return <FavoriteNodeV2 key={favoriteId} favoriteId={favoriteId} />;
        });
    }

    private renderFavoriteNodes(): JSX.Element[] {
        return this.favoritesStore.orderedFavoritesNodeIds.map(nodeId => {
            return <FavoriteNode key={nodeId} favoriteId={nodeId} />;
        });
    }

    private renderContextMenuIfOpen(): JSX.Element {
        const contextMenuState = getMailFavoritesStore().mailFavoritesViewState.contextMenuState;

        // Render the context menu if it is set to be visible
        if (!contextMenuState) {
            return null;
        }

        return (
            <FavoriteNodeContextMenu
                anchorPoint={contextMenuState.anchor}
                nodeId={contextMenuState.nodeId}
                nodeType={contextMenuState.nodeType}
                folder={contextMenuState.folder}
                onDismiss={this.onContextMenuDismissed}
            />
        );
    }

    private renderFindFavoritesComponents = (): JSX.Element[] => {
        return [this.renderAddNewFavoriteNode(), this.renderFavoritesPicker()];
    };

    private renderAddNewFavoriteNode = (): JSX.Element => {
        // Render a TreeNode with empty text if we're showing the picker.
        // This is because we want to preserve the same space as the original 'New favorite' node
        // so that the UI doesn't jump, and blank out the text so it doesn't temporarily show while the
        // picker animates in.
        if (getMailFavoritesStore().mailFavoritesViewState.shouldShowFindFavoritesPicker) {
            return null;
        }

        return (
            <TreeNode
                displayName={loc(addFavoriteLabel)}
                isCustomActionNode={true}
                isRootNode={false}
                key={'newFavorite'}
                onClick={this.onNewFavoriteNodeClicked}
            />
        );
    };

    private renderFavoritesPicker = (): JSX.Element => {
        if (getMailFavoritesStore().mailFavoritesViewState.shouldShowFindFavoritesPicker) {
            return (
                <div className={styles.favoritesPickerContainer}>
                    <FavoritesPicker onItemSelected={this.onItemSelected} />
                </div>
            );
        }

        return null;
    };

    private onItemSelected = (displayName: string) => {
        this.setState({
            favoriteAddedText: format(loc(newFavoritePickedText), displayName),
        });
    };

    private onContextMenuDismissed = () => {
        hideFavoritesContextMenu();
    };

    private onNewFavoriteNodeClicked(evt: React.MouseEvent<unknown> | KeyboardEvent) {
        showFindFavoritesPicker(true /* shouldShow */);
        logUsage('FindFavoritesClicked');
    }
}
